import { Button } from "reactstrap";
import {
  BASE_URL,
  GET_PLANNER_VIEW_LIST,
  GET_PLANNER_DECRPTION_KEY,
} from "utilFunctions/Constants/urlConstants";
import { GET_DOCUMENT_TYPE } from "utilFunctions/Constants/urlConstants";
import { useGetApi } from "utilFunctions/CustomHooks/useGetAPI";
import "./index.css";
import { useContext, useEffect, useState } from "react";
import { selectInterface } from "utilFunctions/shared/PerformanceSearchBar";
import CustomModal from "Components/CommonComponents/CustomModal";
import ConfirmationMessage from "Components/CommonComponents/ConfirmationMessage";
import { ToastContextDispatch, UserInfoContext } from "Context/CommonContext";
import useDeleteData from "utilFunctions/CustomHooks/useDeleteData";
import PDFPageviewer from "Pages/PlannerView/PDFPageviewer";
import { EDP_BRANCH_CODE } from "utilFunctions/Constants/Constants";
import useMasterContext from "Context/MasterContext";
import styled from "styled-components";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import DocumentTypeListingCard from "./DocumentTypeListingCard";
import PlannerHeaderAntd from "Pages/PlannerView/PlannerHeaderAntd";
import PlannerViewTableAntd from "Pages/PlannerView/PlannerViewTableAntd";
const ViewTableContainerDiv: any = styled<any>("div")`
  padding: ${(props: any) =>
    ["xxl", "xl", "lg"].includes(props.screen) ? "20px 20px 20px 48px" : "0px"};
`;
const MainDiv = styled<any>("div")`
  display: flex;
  gap: ${({ screen }: any) =>
    !["xs", "sm", "md"].includes(screen) ? "16px" : "0px"};
  margin-top: ${({ screen }: any) =>
    !["xs", "sm", "md"].includes(screen) ? "16px" : "0px"};
  flex-direction: ${({ screen }: any) =>
    !["xs", "sm", "md"].includes(screen) ? "row" : "column"};
`;
const ScheduledDiv1 = styled<any>("div")`
  width: ${({ screen }: any) =>
    ["xs", "sm", "md"].includes(screen) ? "100%" : "30%"};
  background: ${({ screen }: any) =>
    ["xs", "sm", "md"].includes(screen) ? "#ffffff" : ""};
`;
const ScheduledDiv2 = styled<any>("div")`
  width: ${({ screen }: any) =>
    ["xs", "sm", "md"].includes(screen) ? "100%" : "70%"};
  height: ${({ screen, mode }: any) =>
    ["xs", "sm", "md"].includes(screen)
      ? ["mybatchSyllabus"].includes(mode)
        ? "calc(100% - 110px)"
        : "calc(100% - 160px)"
      : ""};
  background: white;
  border-radius: 12px;
`;
const PlannerViewHome = () => {
  const userInfo = useContext<any>(UserInfoContext);
  const { screen }: any = useWindowSize();
  const fetchUrl = BASE_URL + GET_PLANNER_VIEW_LIST;
  const ToastDispatch = useContext<any>(ToastContextDispatch);
  const { masters } = useMasterContext();
  const [docTypes, setDocTypes] = useState<selectInterface[]>([]);
  const [pdfUrl, setPdfUrl] = useState<string>("");
  const [pdfPassword, setPdfPassword] = useState<string | null>(null);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [filterState, setFilterState] = useState<any>({
    streamList: userInfo?.userStreams[0]?.value,
    acadYearList: null,
    docTypeList: null,
    classList: null,
    phaseList: null,
    subjectList: null,
    chipFieldName: {
      streamList: userInfo?.userStreams[0]?.value,
    },
  });
  const [pagination, setPagination] = useState({
    pageSize: 10,
    total: 10,
    pageSizeOptions: ["10", "50"],
    showSizeChanger: true,
    current: 1,
    sortField: "updatedAt",
    sortOrder: "DESC",
  });
  const [chipShow, setChipShow] = useState<any>({
    streamList: userInfo?.userStreams[0]?.value,
    chipFieldName: {
      streamList: userInfo?.userStreams[0]?.value,
    },
  });
  const [refreshDocument, setRefreshDocument] = useState<boolean>(false);
  const [selectedFile, setSelectedFile] = useState<any>({});
  const [selectedDocType, setSelectedDocType] = useState<any>(null);
  const [isTableFilterApplied] = useState<any>(false);
  const defaultStream: any = userInfo?.userStreams;
  const [selectedStream] = useState<any>(defaultStream[0]);
  const [isSuccessSweetAlert, setIsSuccessSweetAlert] =
    useState<boolean>(false);
  const user_department: any = userInfo?.department;
  const isEDPDepartment: boolean = EDP_BRANCH_CODE.includes(user_department);
  const [open, setOpen] = useState<boolean>(false);
  const { makeRequest: GetDocType, loading: isLoader } = useGetApi(
    (data) => {
      if (data["data"]) {
        const newArray: selectInterface[] = [];
        data["data"].map((ele: any) => {
          newArray.push({
            label: ele.docType,
            key: ele.id,
            value: ele.id,
          });
        });
        setOpen(false);
        setDocTypes(newArray);
        setSelectedDocType(newArray[0]);
      } else {
        setDocTypes([]);
        setSelectedDocType(null);
      }
    },
    (error) => {
      setOpen(false);
      console.error(error);
    }
  );
  console.log(isLoader);
  useEffect(() => {
    if (
      userInfo?.userStreams &&
      Array.isArray(userInfo?.userStreams) &&
      userInfo?.userStreams.length == 1
    ) {
      setFilterState((prevState: any) => ({
        ...prevState,
        streamList: userInfo?.userStreams[0]?.value,
        chipFieldName: {
          streamList: userInfo?.userStreams[0]?.value,
        },
      }));
      setChipShow({
        streamList: userInfo?.userStreams[0]?.value,
        chipFieldName: {
          streamList: userInfo?.userStreams[0]?.value,
        },
      });
    }
  }, [userInfo?.userStreams]);
  useEffect(() => {
    let newUrl = BASE_URL + GET_DOCUMENT_TYPE;
    console.log("newUrlnewUrl", newUrl);
    const filterDatavaluess: any = { ...filterState };
    delete filterDatavaluess["chipFieldName"];
    if (filterState && Object.keys(filterState).length > 0) {
      Object.keys(filterState).map((ele) => {
        const value = Array.isArray(filterState[ele])
          ? filterState[ele] && filterState[ele].map((ele: any) => ele.value)
            ? filterState[ele].map((ele: any) => ele.value)
            : null
          : filterState[ele] != null && filterState[ele].value
          ? filterState[ele].value
          : null;
        filterDatavaluess[ele] = value;
      });
    }
    const filters = [];
    const formValues: any = filterDatavaluess;
    delete formValues["chipFieldName"];
    delete formValues.streamList;
    for (const key in formValues) {
      if (Object.prototype.hasOwnProperty.call(formValues, key)) {
        if (formValues[key] != null && formValues[key] != "") {
          filters.push(
            encodeURIComponent(key) + "=" + encodeURIComponent(formValues[key])
          );
        }
      }
    }

    if (selectedStream != null && ["xxl", "xl", "lg"].includes(screen)) {
      newUrl = newUrl + "?streamList=" + selectedStream.value;
    }
    if (Array.isArray(filters) && filters.length > 0) {
      newUrl = newUrl + "&" + filters.join("&");
    }
    if (
      selectedStream != null &&
      ["xs", "sm", "md"].includes(screen) &&
      (formValues["streamList"] == "" || formValues["streamList"] == null)
    ) {
      newUrl = newUrl + "?streamList=" + selectedStream.value;
    }
    console.log("newUrlnewUrl", newUrl, formValues);
    GetDocType(newUrl);
  }, []);
  const { makeRequest: DeleteAPIHandler } = useDeleteData(
    (data: any) => {
      ToastDispatch({
        isOpen: true,
        type: "Success",
        message: data.message,
      });
      setSelectedFile({});
      setTimeout(() => {
        setRefreshDocument(!refreshDocument);
      }, 1000);
    },
    (error) => {
      ToastDispatch({
        isOpen: true,
        type: "Error",
        message: error["response"]["data"]["message"],
      });
    },
    "DELETE"
  );
  const { makeRequest: fetchFile } = useGetApi(
    (data) => {
      setPdfUrl(data?.data?.s3Path);
      setIsOpen(!isOpen);
    },
    (error) => {
      console.error(error);
    }
  );
  const { makeRequest: fetchFileDecryptionKey } = useGetApi(
    (data) => {
      if (data?.detailMessage) {
        const decodedKey = atob(data?.detailMessage);
        setPdfPassword(decodedKey);
      } else {
        setPdfPassword("NO_PASSWORD");
      }
    },
    (error) => {
      setPdfPassword("NO_PASSWORD");
      console.error(error);
    }
  );
  const handlePDFView = (item: any) => {
    setSelectedFile(item);
    fetchFile(BASE_URL + GET_PLANNER_VIEW_LIST + `/${item.id}`);
    fetchFileDecryptionKey(BASE_URL + GET_PLANNER_DECRPTION_KEY + `${item.id}`);
  };
  const handleDeleteDocument = (item: any) => {
    setSelectedFile(item);
    setIsSuccessSweetAlert(true);
  };
  const deleteDocumentHandler = () => {
    const urls: any = BASE_URL + GET_PLANNER_VIEW_LIST + `/${selectedFile.id}`;
    DeleteAPIHandler(urls);
  };

  const handleAppliedFilter = (filterState: any) => {
    console.log("filterState filterState", filterState);
    let newUrl = BASE_URL + GET_DOCUMENT_TYPE;
    const filterDatavaluess: any = { ...filterState };
    const filters = [];
    const formValues: any = filterDatavaluess;
    console.log(selectedStream, "GET_DOCUMENT_TYPE", filterState, formValues);
    delete formValues.chipFieldName;
    for (const key in formValues) {
      if (Object.prototype.hasOwnProperty.call(formValues, key)) {
        if (formValues[key] != null && formValues[key] != "") {
          filters.push(
            encodeURIComponent(key) + "=" + encodeURIComponent(formValues[key])
          );
        }
      }
    }

    // if (selectedStream != null && ["xxl", "xl", "lg"].includes(screen)) {
    //   newUrl = newUrl + "?streamList=" + selectedStream.value;
    // }
    if (Array.isArray(filters) && filters.length > 0) {
      newUrl = newUrl + "?" + filters.join("&");
    }
    if (
      selectedStream != null &&
      ["xs", "sm", "md"].includes(screen) &&
      (formValues["streamList"] == "" || formValues["streamList"] == null)
    ) {
      newUrl = newUrl + "?streamList=" + selectedStream.value;
    }
    setPagination({
      pageSize: 10,
      total: 10,
      pageSizeOptions: ["10", "50"],
      showSizeChanger: true,
      current: 1,
      sortField: "updatedAt",
      sortOrder: "DESC",
    });
    setTimeout(() => {
      setRefreshDocument(!refreshDocument);
      GetDocType(newUrl);
    }, 100);
  };
  return (
    <>
      {isSuccessSweetAlert && (
        <ConfirmationMessage
          warning={false}
          warningMessage="Are you sure want to delete this document?"
          onCancel={() => {
            setIsSuccessSweetAlert(false);
          }}
          onConfirm={() => {
            setIsSuccessSweetAlert(false);
            deleteDocumentHandler();
          }}
          isSuccessSweetAlert={isSuccessSweetAlert}
          message={
            "This document will not be visible to anyone once it is deleted"
          }
        />
      )}
      <ViewTableContainerDiv screen={screen}>
        <div>
          <PlannerHeaderAntd
            filterState={filterState}
            setFilterState={setFilterState}
            handleAppliedFilter={handleAppliedFilter}
            open={open}
            setOpen={setOpen}
            userInfo={userInfo}
            isEDPDepartment={isEDPDepartment}
            chipShow={chipShow}
            setChipShow={setChipShow}
            stream={masters?.streams}
            acadYears={masters?.acadYears}
            classes={masters?.classes}
            docTypes={docTypes}
            subjects={userInfo?.subjectsListing}
            setPagination={setPagination}
          ></PlannerHeaderAntd>

          <MainDiv screen={screen}>
            {!["xs", "sm", "md"].includes(screen) && (
              <ScheduledDiv1 screen={screen} mode={"mybatchSyllabus"}>
                <DocumentTypeListingCard
                  selectedDocType={selectedDocType}
                  setSelectedDocType={setSelectedDocType}
                  docTypes={docTypes}
                ></DocumentTypeListingCard>
              </ScheduledDiv1>
            )}
            <ScheduledDiv2 screen={screen} mode={"mybatchSyllabus"}>
              <PlannerViewTableAntd
                userInfo={userInfo}
                refreshTable={refreshDocument}
                isTableFilterApplied={isTableFilterApplied}
                fetchUrl={fetchUrl}
                stream={masters?.streams}
                acadYears={masters?.acadYears}
                classes={masters?.classes}
                docTypes={docTypes}
                selectedFile={selectedFile}
                handlePDFView={handlePDFView}
                handleDeleteDocument={handleDeleteDocument}
                isEDPDepartment={isEDPDepartment}
                selectedDocType={selectedDocType}
                selectedStream={selectedStream}
                filterState={filterState}
                pagination={pagination}
                setPagination={setPagination}
                customRenderers={() => (
                  <div>
                    <Button color="info" size="sm">
                      view
                    </Button>
                    <Button color="info" size="sm">
                      delete
                    </Button>
                  </div>
                )}
              ></PlannerViewTableAntd>
            </ScheduledDiv2>
          </MainDiv>
        </div>
        <CustomModal
          modal={isOpen}
          centered={true}
          backdrop={true}
          size={"xl"}
          fullscreen={true}
          toggle={() => {
            setPdfUrl("");
            setSelectedFile({});
            setIsOpen(!isOpen);
            setPdfPassword(null);
          }}
        >
          <div className="PDFContainer">
            {pdfUrl != "" && pdfPassword != null ? (
              <PDFPageviewer
                allPageInOne={true}
                pdfUrl={pdfUrl}
                pdfPassword={pdfPassword}
              />
            ) : null}
          </div>
        </CustomModal>
      </ViewTableContainerDiv>
    </>
  );
};

export default PlannerViewHome;
